import { HttpErrorResponse } from '@angular/common/http';
import { ErrorHandler, Injectable, Injector, NgZone } from '@angular/core';
import { ToastrService } from 'ngx-toastr';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
    private handledErrors = new Set<string>();

    constructor(private injector: Injector, private zone: NgZone) { }

    handleError(err: any): void {

        const errorKey = this.generateErrorKey(err);

        // Prevent perpetual error cycle by checking if this error is already handled
        if (this.handledErrors.has(errorKey)) {
            return;
        }
        this.handledErrors.add(errorKey);

        const toastr = this.injector.get(ToastrService);
        let message: string = "An unexpected error occurred.";

        if (typeof err === 'string') {
            message = err;
        } else if (err instanceof Error) {
            message = err.message;
        } else if (err instanceof HttpErrorResponse) {
            message = typeof err.error === 'string'
                ? `${err.status}: ${err.error}`
                : `${err.status}: ${err.error?.message || err.message}`;
        }

        console.error(err);

        this.zone.run(() => {
            toastr.error(message, "Error");
        });

        // Optional: Clear the errors periodically to avoid memory leaks
        setTimeout(() => {
            console.warn('Perpetual error detected: ' + errorKey);
            this.handledErrors.clear();
        }, 5000);
    }

    private generateErrorKey(error: any): string {
        return error?.message || JSON.stringify(error);
    }
}
